import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';

import { Profile } from './../../../_common/profile';
import { Personal } from './../../../_common/personal';

export const EditProfile = () => {
	const user = useSelector(state => state.user);
	const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
	const [credentials, setCredentials] = useState({
		email: !R.isNil(user.user) && !R.isNil(user.user.email) ? user.user.email : '',
		password: '',
		confirmPassword: ''
	});
	const credentialsForm = useRef(null);
	const [wasValidated, setWasValidated] = useState(false);

	return (
		<div className="modal fade px-0" id="EditProfile" aria-labelledby="EditProfileLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-lg modal-dialog-scrollable">
				<div className="modal-content pr-4">
					<header className="modal-header mr-n4">
						<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Edit User</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="EditProfileLabel">Modifier données personnelles</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body py-0 scroll-default pr-3">
						<Personal isSettings={true} inModal={true} />
					</div>
					<div className="modal-footer mr-n4">
						<button type="button" className="btn btn-faded" data-dismiss="modal">Annuler</button>
						<button type="button" className="btn btn-secondary loading-btn">Sauvegarder<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
					</div>
				</div>
			</div>
		</div>
	)
}